import {querySearch, queryOne, command} from "../utils/api";

const RETURN_REASONS_URL = `${process.env.PUBLIC_URL}/api/v1/r/returnReasons`;

export const SEARCH_RETURN_REASONS = 'SEARCH_RETURN_REASONS';
export const SEARCH_RETURN_REASONS_COMPLETED = 'SEARCH_RETURN_REASONS_COMPLETED';
export const SEARCH_RETURN_REASONS_FAILED = 'SEARCH_RETURN_REASONS_FAILED';
export const searchReturnReasons = querySearch(RETURN_REASONS_URL, SEARCH_RETURN_REASONS,
  SEARCH_RETURN_REASONS_COMPLETED, SEARCH_RETURN_REASONS_FAILED, ['name']);

export const GET_RETURN_REASON = 'GET_RETURN_REASON';
export const GET_RETURN_REASON_COMPLETED = 'GET_RETURN_REASON_COMPLETED';
export const GET_RETURN_REASON_FAILED = 'GET_RETURN_REASON_FAILED';
export const getReturnReason = ({returnReasonId}) => queryOne(
  RETURN_REASONS_URL, {where: {returnReasonId}, order: 'name ASC'},
  GET_RETURN_REASON, GET_RETURN_REASON_COMPLETED, GET_RETURN_REASON_FAILED
);

const RETURN_REASON_URL = `${process.env.PUBLIC_URL}/api/v1/returnReason`;

export const ADD_RETURN_REASON = 'ADD_RETURN_REASON';
export const ADD_RETURN_REASON_COMPLETED = 'ADD_RETURN_REASON_COMPLETED';
export const ADD_RETURN_REASON_FAILED = 'ADD_RETURN_REASON_FAILED';
export const addReturnReason = command(RETURN_REASON_URL + '/addReturnReason', ADD_RETURN_REASON,
  ADD_RETURN_REASON_COMPLETED, ADD_RETURN_REASON_FAILED);

export const UPDATE_RETURN_REASON = 'UPDATE_RETURN_REASON';
export const UPDATE_RETURN_REASON_COMPLETED = 'UPDATE_RETURN_REASON_COMPLETED';
export const UPDATE_RETURN_REASON_FAILED = 'UPDATE_RETURN_REASON_FAILED';
export const updateReturnReason = command(RETURN_REASON_URL + '/updateReturnReason', UPDATE_RETURN_REASON,
  UPDATE_RETURN_REASON_COMPLETED, UPDATE_RETURN_REASON_FAILED);

export const UPDATE_RETURN_REASON_VISIBILITY = 'UPDATE_RETURN_REASON_VISIBILITY';
export const UPDATE_RETURN_REASON_VISIBILITY_COMPLETED = 'UPDATE_RETURN_REASON_VISIBILITY_COMPLETED';
export const UPDATE_RETURN_REASON_VISIBILITY_FAILED = 'UPDATE_RETURN_REASON_VISIBILITY_FAILED';
export const updateReturnReasonVisibility = command(RETURN_REASON_URL + '/updateReturnReasonVisibility',
  UPDATE_RETURN_REASON_VISIBILITY, UPDATE_RETURN_REASON_VISIBILITY_COMPLETED, UPDATE_RETURN_REASON_VISIBILITY_FAILED);



// WEBPACK FOOTER //
// ./src/ReturnReason/actions.js